import { CartModel } from "atoms/models";
import ICalendarLink from "react-icalendar-link";

const CalendarDownload: React.FC<{ cart: CartModel }> = ({ cart }) => {
  const calendarEvent = {
    title: "Comporium Service(s) Installation",
    description:
      "Please have someone 18 years or older present during our visit. Thank you for choosing Comporium as your service provider.",
    startTime: `${new Date(cart?.schedule?.nonSecuritySchedule?.startTime)}`,
    endTime: `${new Date(cart?.schedule?.nonSecuritySchedule?.endTime)}`,
    location: `${cart.billingStreetNumber} ${cart.billingStreetName} ${cart.billingCity} ${cart.billingState} ${cart.billingZipCode}`,
    attendees: [`${cart.customerNameFirst} ${cart.customerNameLast} <${cart.emailAddress}>`],
  };
  return (
    <div>
      <ICalendarLink filename='comporium-appointment.ics' event={calendarEvent} className='btn btn-primary btn-lg calendar-download-button'>
        <i className='fa-regular fa-calendar-days fa-download-cal-reminder me-2' aria-hidden='true'></i>Download Calendar Reminder
      </ICalendarLink>
    </div>
  );
};

export default CalendarDownload;
